<template lang="pug">
  div.d-flex.align-items-center
    span.mr-2 Валюта:
    ul.currency-selector.list-unstyled.text-nowrap
      li(
        v-for="currency in supportedCurrencies"
        :key="currency.isoCode"
        :class="{ active: currency.isoCode === selectedCurrencyIso }"
        @click.prevent="selectedCurrencyIso = currency.isoCode"
      ) {{currency.isoCode}}
</template>

<script>
  import { SUPPORTED_CURRENCIES, selectedCurrencyIsoRef } from '@app_shared/ecommerce.js.erb';

  export default {
    setup () {
      return {
        selectedCurrencyIso: selectedCurrencyIsoRef,
        supportedCurrencies: SUPPORTED_CURRENCIES,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .currency-selector {
    border-radius: 6px;
    display: flex;
    overflow: hidden;

    li {
      padding: 4px 10px;
      font-weight: 500;
      font-size: 14px;
      cursor: pointer;

      transition: all 0.2s;

      background: $white;
      color: $oslo-gray;

      &.active {
        color: white;
        background: $java;
      }

      &:not(.active):hover {
        color: $java;
      }
    }
  }
</style>